import { PATH } from "constants/path"
import { getTabId } from "components/DownloadProcess/downloadQueue"

interface SavedWorkspaceData {
  wsCode: string
  token: string
}

export const getSavedWsCode = (isToken = false): string | null => {
  const tabId = getTabId()
  const saved = localStorage.getItem(`last_ws_data_${tabId}`)
  if (!saved) return null

  try {
    const data: SavedWorkspaceData = JSON.parse(saved)
    return isToken ? data.token : data.wsCode || null
  } catch {
    return null
  }
}

export const saveWsCode = (wsCode: string, newToken: string): void => {
  const tabId = getTabId()
  const data: SavedWorkspaceData = {
    wsCode,
    token: newToken,
  }
  localStorage.setItem(`last_ws_data_${tabId}`, JSON.stringify(data))
}

// Copy wsCode data từ tab cũ sang tab mới
export const copyWsCodeToNewTab = (
  sourceTabId: string,
  targetTabId: string
): void => {
  const sourceData = localStorage.getItem(`last_ws_data_${sourceTabId}`)
  if (sourceData) {
    localStorage.setItem(`last_ws_data_${targetTabId}`, sourceData)
  }
}

export const routesWithoutWsCode = [
  PATH.organizationAdd,
  PATH.inviteesPCB,
  PATH.inviteesBuildPCB,
  PATH.inviteesBOM,
  PATH.inviteesMechComponent,
  PATH.inviteesBuildMechComponent,
  PATH.inviteesOther,
  PATH.inviteesBuildOther,
  PATH.conversations,
]

export const getWsCodeFromUrl = (): string | undefined => {
  const fullPath = window.location.pathname
  const pathSegments = fullPath.split("/").filter(Boolean)
  const firstSegment = pathSegments[0]
  // Check if first segment matches ws_code pattern (uppercase alphanumeric)
  if (firstSegment && firstSegment.match(/^[A-Z0-9]+$/)) {
    return firstSegment
  }
  return undefined
}

// Function để kiểm tra route có nằm trong danh sách routes không được phép có ws_code không
export const isRouteNotAllowedWithWsCode = (pathname: string): boolean => {
  return routesWithoutWsCode.some((route) => {
    if (pathname === route) return true
    // Check for routes with parameters
    if (route.includes(":") && pathname.startsWith(route.split(":")[0]))
      return true
    return pathname.startsWith(route)
  })
}

export const hasWsCodePrefix = (pathname: string): boolean => {
  const pathSegments = pathname.split("/").filter(Boolean)
  const firstSegment = pathSegments[0]
  // Check if first segment matches ws_code pattern (uppercase alphanumeric)
  return firstSegment ? !!firstSegment.match(/^[A-Z0-9]+$/) : false
}

export const removeWsCodePrefix = (pathname: string): string => {
  const pathSegments = pathname.split("/").filter(Boolean)
  const firstSegment = pathSegments[0]
  // Check if first segment matches ws_code pattern (uppercase alphanumeric)
  if (firstSegment && firstSegment.match(/^[A-Z0-9]+$/)) {
    const pathWithoutWsCode = "/" + pathSegments.slice(1).join("/")
    return pathWithoutWsCode || "/"
  }
  return pathname
}

export const addWsCodePrefixToPath = (
  pathname: string | undefined
): string | undefined => {
  if (!pathname) return pathname
  const wsCode = getSavedWsCode()
  if (
    wsCode &&
    !hasWsCodePrefix(pathname) &&
    !isRouteNotAllowedWithWsCode(pathname)
  ) {
    return `/${wsCode}${pathname}`
  }
  return pathname
}
